import { Sound } from '@pixi/sound';
export const bellSound = Sound.from( 'assets/music/bell.mp3');
export const matchSound = Sound.from('assets/music/match.mp3');
export const paperSound = Sound.from('assets/music/paper.mp3');
export const plopSound = Sound.from('assets/music/plop.mp3');
export const sinkSound = Sound.from('assets/music/sink.mp3');
export const sirenSound = Sound.from('assets/music/siren.mp3');
export const slideSound = Sound.from('assets/music/slide.mp3');
